"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeMaintConfig = exports.normalizeDateTimeToEpoch = exports.getSiteConfig = exports.getNormalizedMaintConfig = exports.getDefaultScheduledMaintConfig = exports.getDefaultMainframeIPLMaintConfig = exports.MAINT_TYPE_SCHEDULED = exports.MAINT_TYPE_MF_IPL = exports.DATE_TIME_SRC_DELTA_THRESHOLD = void 0;
var _date = require("./type-checks/date");
var _isDefined = require("./misc-checks/isDefined");
var _getDateTime = require("./getDateTime");
var _common = require("../config/common");
const DATE_TIME_SRC_DELTA_THRESHOLD = exports.DATE_TIME_SRC_DELTA_THRESHOLD = 1000;
const MAINT_TYPE_MF_IPL = exports.MAINT_TYPE_MF_IPL = "mf-ipl";
const MAINT_TYPE_SCHEDULED = exports.MAINT_TYPE_SCHEDULED = "scheduled";
const getDefaultMainframeIPLMaintConfig = currentDateTime => {
  let now = new Date(currentDateTime);
  let startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  let secondSunday = new Date(new Date(startOfMonth).setDate(1 + (0 - startOfMonth.getDay() + 7) % 7 + 7));
  let priorFriday = new Date(new Date(secondSunday).setDate(secondSunday.getDate() - 2));
  let maintBegin = new Date(secondSunday).setHours(5, 0, 0, 0);
  let maintEnd = new Date(secondSunday).setHours(10, 0, 0, 0);
  let messageBegin = new Date(priorFriday).setHours(9, 0, 0, 0);
  let messageEnd = maintEnd;
  return {
    maintBegin,
    maintEnd,
    messageBegin,
    messageEnd
  };
};
exports.getDefaultMainframeIPLMaintConfig = getDefaultMainframeIPLMaintConfig;
const getDefaultScheduledMaintConfig = config => {
  let maintBegin = new Date(config.maintBegin).getTime();
  let maintEnd = new Date(config.maintEnd).getTime();
  let startOfMaint = new Date(maintBegin);
  let messageBegin = new Date(startOfMaint.setDate(startOfMaint.getDate() - 2)).setHours(9, 0, 0, 0);
  let messageEnd = maintEnd;
  return {
    maintBegin,
    maintEnd,
    messageBegin,
    messageEnd
  };
};
exports.getDefaultScheduledMaintConfig = getDefaultScheduledMaintConfig;
const getNormalizedMaintConfig = config => {
  let {
    maintBegin,
    maintEnd,
    messageBegin,
    messageEnd,
    ...rest
  } = config;
  (0, _isDefined.isDefined)(maintBegin) && (maintBegin = normalizeDateTimeToEpoch(maintBegin));
  (0, _isDefined.isDefined)(maintEnd) && (maintEnd = normalizeDateTimeToEpoch(maintEnd));
  (0, _isDefined.isDefined)(messageBegin) && (messageBegin = normalizeDateTimeToEpoch(messageBegin));
  (0, _isDefined.isDefined)(messageEnd) && (messageEnd = normalizeDateTimeToEpoch(messageEnd));
  return {
    maintBegin,
    maintEnd,
    messageBegin,
    messageEnd,
    ...rest
  };
};

/**
 * Normalizes datetime to epoch value;
 *
 * @name normalizeDateTimeToEpoch
 * @param {variable} datetime Value to create date object from
 * @returns {variable} Normalized epoch time value or null if unsuccessful
 */
exports.getNormalizedMaintConfig = getNormalizedMaintConfig;
const normalizeDateTimeToEpoch = dateTime => {
  const normalizedDateTime = new Date(dateTime);
  return (0, _date.isDate)(normalizedDateTime) ? normalizedDateTime.getTime() : null;
};
exports.normalizeDateTimeToEpoch = normalizeDateTimeToEpoch;
const normalizeMaintConfig = (maintConfigList, currentDateTime) => {
  const normalizedConfigs = [];
  maintConfigList.forEach(config => {
    const {
      type
    } = config;
    if (type === MAINT_TYPE_SCHEDULED) {
      let {
        id,
        maintBegin,
        maintEnd,
        messageBegin,
        messageEnd
      } = {
        ...getNormalizedMaintConfig({
          ...getDefaultScheduledMaintConfig(config),
          ...config
        })
      };
      normalizedConfigs.push({
        id,
        isInMaint: currentDateTime >= maintBegin && currentDateTime < maintEnd,
        isInMessage: currentDateTime >= messageBegin && currentDateTime < messageEnd,
        maintBegin,
        maintEnd,
        messageBegin,
        messageEnd,
        type
      });
    } else if (type === MAINT_TYPE_MF_IPL) {
      let {
        maintBegin,
        maintEnd,
        messageBegin,
        messageEnd
      } = {
        ...getNormalizedMaintConfig({
          ...getDefaultMainframeIPLMaintConfig(currentDateTime),
          ...config
        })
      };
      normalizedConfigs.push({
        id: type,
        isInMaint: currentDateTime >= maintBegin && currentDateTime < maintEnd,
        isInMessage: currentDateTime >= messageBegin && currentDateTime < messageEnd,
        maintBegin,
        maintEnd,
        messageBegin,
        messageEnd,
        type
      });
    }
  });
  return normalizedConfigs;
};

/**
 * Returns site configuration object
 *
 * @name getSiteConfig
 * @param {string} [url=URL_PUBLIC_CONFIG] URL to retrieve configuration from
 * @param {object} [requestConfig={}] Configuration request settings
 * @returns {Promise<object>} ID values derived from prefix and a UUID value
 */
exports.normalizeMaintConfig = normalizeMaintConfig;
const getSiteConfig = async function () {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _common.URL_PUBLIC_CONFIG;
  let requestConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const response = await fetch(url, requestConfig);
  const responseHeaders = response.headers;
  const responseBody = await response.json();
  const clientDateTime = new Date().getTime();
  const remoteDateTime = new Date(responseHeaders.get(_common.HEADER_KEY_DATE)).getTime();
  const dateTimeSrc = clientDateTime - remoteDateTime <= DATE_TIME_SRC_DELTA_THRESHOLD ? _getDateTime.DATE_TIME_SRC_CLIENT : _getDateTime.DATE_TIME_SRC_REMOTE;
  const config = {
    ...responseBody,
    dateTimeSrc,
    maintenance: normalizeMaintConfig(responseBody.maintenance, remoteDateTime)
  };
  return config;
};
exports.getSiteConfig = getSiteConfig;